import { render, staticRenderFns } from "./ProgramingStartSection.vue?vue&type=template&id=ae4a2724&scoped=true&"
import script from "./ProgramingStartSection.vue?vue&type=script&lang=ts&"
export * from "./ProgramingStartSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramingStartSection.vue?vue&type=style&index=0&id=ae4a2724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4a2724",
  null
  
)

export default component.exports